export const genderEnum = [
    {
        stateId: "MAN",
        stateName: "男"
    },
    {
        stateId: "WOMAN",
        stateName: "女"
    },
    {
        stateId: "UNKNOWN",
        stateName: "未知"
    }
]
